import requests from "./httpService";
import DataParser from "../utlits/Dataparser";

const CompanyShiftService = {
    getAll() {
        return requests.get(`/${DataParser.CompanyId()}/companyshifts`);
    },
    create(body) {
        return requests.post(`/${DataParser.CompanyId()}/companyshifts/create`, body);
    },
    delete(id) {
        return requests.delete(`/${DataParser.CompanyId()}/companyshifts/${id}`);
    },
    getSingle(id) {
        return requests.get(`/${DataParser.CompanyId()}/companyshifts/${id}`);
    },
    update(id, body) {
        return requests.put(`/${DataParser.CompanyId()}/companyshifts/${id}`, body);
    },
    duplicate(id) {
        return requests.post(`/${DataParser.CompanyId()}/companyshifts/duplicate/${id}`, {});
    }
};

export default CompanyShiftService;
